module.exports = __webpack_public_path__ + "static/media/19.2a0e570a.JPG";